var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog-old',{ref:"dialog",staticClass:"dialog",attrs:{"id":"treeDialog"}},[_c('div',{staticClass:"tree"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"tree-list"},_vm._l((_vm.children),function(node){return _c('node-tree',{key:node.id,attrs:{"node":node}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }